// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-documentation-form {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 3rem;
  width: 100%;
}
.upload-documentation-form .upload-files-button-container {
  width: 100%;
  display: flex;
  gap: 1rem;
}
.upload-documentation-form .upload-files-button-container .upload-files-button {
  flex: 1;
  width: 80%;
  margin: 0 auto;
}
.upload-documentation-form .upload-files-button-container .done-button {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/DocumentUploadForm/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,SAAA;AACJ;AACI;EACE,OAAA;EACA,UAAA;EACA,cAAA;AACN;AAEI;EACE,OAAA;AAAN","sourcesContent":[".upload-documentation-form {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 3rem;\n  width: 100%;\n\n  .upload-files-button-container {\n    width: 100%;\n    display: flex;\n    gap: 1rem;\n\n    .upload-files-button {\n      flex: 1;\n      width: 80%;\n      margin: 0 auto;\n    }\n\n    .done-button {\n      flex: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
